/**
 * This locale is set to window.document by the site that loads our zerpa application
 * Before it was Wordpress and now Typo3 sets this value before loading the application
 */
export const getLocaleFromDOM = (): string | null => {
  if (!document.getElementById('root')) {
    return 'de_DE';
  }
  const rootEl = document.getElementById('root');
  if (rootEl) {
    return rootEl.getAttribute('data-wplocale');
  }
  return null;
};

export const getGlobalBaseName = (): string => {
  const domLocale = getLocaleFromDOM();
  return domLocale ? `${domLocale}/zerpa` : '';
};

export const mapDOMLocaleToReactIntl = (): string => {
  switch (getLocaleFromDOM()) {
    case 'en_GB':
      return 'en';
    case 'de_DE':
      return 'de';
    default:
      return 'de';
  }
};
